import { zipSync, strToU8 } from "fflate";
import { toPng } from "html-to-image";

export const SIZES = {
  square: { w: 1080, h: 1080, label: "Instagram square 1:1" },
  portrait: { w: 1080, h: 1350, label: "Instagram post 4:5" },
  story: { w: 1080, h: 1920, label: "Story / Reel 9:16" },
  og: { w: 1200, h: 630, label: "Facebook / OG" },
  banner: { w: 1500, h: 500, label: "X banner" },
};

// the hidden stage renders at real pixel size, so pixelRatio stays 1
export const nodeToPng = (node) =>
  toPng(node, { pixelRatio: 1, cacheBust: true, backgroundColor: getComputedStyle(node).backgroundColor });

const b64ToBytes = (b64) => {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
};

export const buildZip = async (name, files, extras = {}) => {
  const entries = {};
  files.forEach(({ filename, dataUrl }) => {
    entries[filename] = b64ToBytes(dataUrl.split(",")[1]);
  });
  Object.entries(extras).forEach(([filename, text]) => {
    if (text) entries[filename] = typeof text === "string" ? strToU8(text) : text;
  });
  const blob = new Blob([zipSync(entries, { level: 6 })], { type: "application/zip" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.zip`;
  a.click();
  URL.revokeObjectURL(url);
};

export const captionFile = (copy) => {
  if (!copy) return "";
  const tags = (copy.hashtags || []).map((h) => `#${h}`).join(" ");
  return `${copy.caption || ""}\n\n${tags}\n\nALT: ${copy.alt_text || ""}\n`;
};
